import { legacyBillingStoreConnect } from 'src/state/store';
import { MakoStateType } from 'src/state/types/makoStateType';
import { ComponentType } from 'react';

export const mapStateToProps = (state: MakoStateType) => ({
  showUnifiedTeammateSwitcherFlag: Boolean(
    state.accountOfferings.entitlements
      ?.compat_multiple_account_access_teammate_linking_beta
  ),
});

export type AccountOfferingsConnectorStateProps = ReturnType<
  typeof mapStateToProps
>;

export function withAccountOfferingsConnector<P>(
  Component: ComponentType<P>
): ComponentType<any> {
  return legacyBillingStoreConnect(mapStateToProps)(Component as any);
}
